import React from 'react';

function LoadingSpinner() {
  return (
    <div className="flex justify-center items-center h-64">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      <span className="sr-only">جاري التحميل...</span>
    </div>
  );
}

export default LoadingSpinner; 